import {RouteHelper, RouteInfo} from "../../route/RouteHelper";

export const SidebarItemsType = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    HEADER_ITEM: "HEADER_ITEM",
}

export const sidebarItems = [
    {
        info: RouteInfo.Dashboard,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.MagazineList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.TourLeadersList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.ManagersList,
        type: SidebarItemsType.COLLAPSE,
    }, {
        info: RouteInfo.QUESTIONS,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.FILE_MANAGER,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.REPORTS,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.LEARNS,
        type: SidebarItemsType.SIMPLE_ITEM
    },
]


export const advanceSidebarItemTypes = {
    COLLAPSE: "COLLAPSE",
    SIMPLE_ITEM: "SIMPLE_ITEM",
    SIMPLE_CHILD: "SIMPLE_CHILD",
    ROOT_ITEM: "ROOT_ITEM",
}

export const advanceSidebarItems = [
    {
        info: RouteHelper.Dashboard,
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Funds,
        parent: null
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.FundsSuperAdmin,
        parent: RouteHelper.Funds
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.FundsList,
        parent: RouteHelper.Funds
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.FundAdminsList,
        parent: RouteHelper.Funds
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.Union,
        parent: RouteHelper.Funds,
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Magazine,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineNews,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineProjects,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineVideos,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.NotificationsList,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineSlider,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.MagazineCharts,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.Forms,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.FileManager,
        parent: RouteHelper.Magazine
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Managers,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.ManagersList,
        parent: RouteHelper.Managers
    },

    {
        type: advanceSidebarItemTypes.SIMPLE_ITEM,
        info: RouteHelper.ContactUs,
        parent: null,
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Setting,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.VersionControl,
        parent: null
    },
    {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.Features,
        parent: RouteHelper.Magazine,
    },
    /*{
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.PaymentGateway,
        parent: null
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.PaymentGatewaysList,
        parent: RouteHelper.PaymentGateway
    }, {
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        info: RouteHelper.TransactionsList,
        parent: RouteHelper.PaymentGateway,
    },
    {
        type: advanceSidebarItemTypes.ROOT_ITEM,
        info: RouteHelper.Users,
        parent: null
    },
    {
        info: RouteHelper.UsersList,
        type: advanceSidebarItemTypes.SIMPLE_CHILD,
        parent: RouteHelper.Users
    },*/

]

export const sideBarListItemsClerk = [
    {
        info: "خانه",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Dashboard,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "مدیریت",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.ManagersList,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "کامپوننت های آماده",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.DefaultListPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.DefaultInputsPage,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Category,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.Exam,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "فایل ها",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Files,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "نمودار ها",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.Charts,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.SimpleBarChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.PieChartWithPaddingAngle,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.SimplePieChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.VerticalBarChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.DoughnutChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.PieChart,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: "اسناد",
        type: SidebarItemsType.HEADER_ITEM
    }, {
        info: RouteInfo.ReleaseDocuments,
        type: SidebarItemsType.SIMPLE_ITEM
    }, {
        info: RouteInfo.AppVersionList,
        type: SidebarItemsType.SIMPLE_ITEM
    },


]


